<script>
  import Icon from "./Icon.svelte";

  export let name;
  export let size = 24;
  export let fill = null;
  export let stroke = null;
  export let mb = 6;
  export let title;
</script>

<div class="flex items-center mb-{mb}">
  <div class="mr-1">
    <Icon {name} {fill} {size} {stroke} />
  </div>
  <p class="text-neutral-2">{@html title}</p>
</div>
